export default "__VITE_ASSET__5baf9ead__"